/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  GetCustomer200Response,
  GetCustomer404Response,
  GetCustomerById200Response,
  GetCustomerProducts200Response,
  GetCustomerPromotions200Response,
  GetCustomerVisits200Response,
  GetProductsFiltersParameterInnerInner,
  GetProductsPaginationParameter,
  GetProductsSortingParameterInner,
  UpdateCustomerRequest,
} from '../models/index';
import {
    GetCustomer200ResponseFromJSON,
    GetCustomer200ResponseToJSON,
    GetCustomer404ResponseFromJSON,
    GetCustomer404ResponseToJSON,
    GetCustomerById200ResponseFromJSON,
    GetCustomerById200ResponseToJSON,
    GetCustomerProducts200ResponseFromJSON,
    GetCustomerProducts200ResponseToJSON,
    GetCustomerPromotions200ResponseFromJSON,
    GetCustomerPromotions200ResponseToJSON,
    GetCustomerVisits200ResponseFromJSON,
    GetCustomerVisits200ResponseToJSON,
    GetProductsFiltersParameterInnerInnerFromJSON,
    GetProductsFiltersParameterInnerInnerToJSON,
    GetProductsPaginationParameterFromJSON,
    GetProductsPaginationParameterToJSON,
    GetProductsSortingParameterInnerFromJSON,
    GetProductsSortingParameterInnerToJSON,
    UpdateCustomerRequestFromJSON,
    UpdateCustomerRequestToJSON,
} from '../models/index';

export interface GetCustomerRequest {
    phoneNumber: string;
}

export interface GetCustomerByIdRequest {
    id: string;
}

export interface GetCustomerProductsRequest {
    id: string;
    pagination?: GetProductsPaginationParameter;
    filters?: Array<Array<GetProductsFiltersParameterInnerInner>>;
    sorting?: Array<GetProductsSortingParameterInner>;
    startDate?: Date;
    endDate?: Date;
}

export interface GetCustomerPromotionsRequest {
    id: string;
    pagination?: GetProductsPaginationParameter;
    filters?: Array<Array<GetProductsFiltersParameterInnerInner>>;
    sorting?: Array<GetProductsSortingParameterInner>;
    startDate?: Date;
    endDate?: Date;
}

export interface GetCustomerVisitsRequest {
    id: string;
    pagination?: GetProductsPaginationParameter;
    filters?: Array<Array<GetProductsFiltersParameterInnerInner>>;
    sorting?: Array<GetProductsSortingParameterInner>;
    startDate?: Date;
    endDate?: Date;
}

export interface UpdateCustomerOperationRequest {
    id: string;
    updateCustomerRequest?: UpdateCustomerRequest;
}

/**
 * 
 */
export class CustomersApi extends runtime.BaseAPI {

    /**
     */
    async bulkImportCustomersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/customers/bulk`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async bulkImportCustomers(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.bulkImportCustomersRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getCustomerRaw(requestParameters: GetCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCustomer200Response>> {
        if (requestParameters['phoneNumber'] == null) {
            throw new runtime.RequiredError(
                'phoneNumber',
                'Required parameter "phoneNumber" was null or undefined when calling getCustomer().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['phoneNumber'] != null) {
            queryParameters['phoneNumber'] = requestParameters['phoneNumber'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/customers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetCustomer200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getCustomer(requestParameters: GetCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCustomer200Response> {
        const response = await this.getCustomerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getCustomerByIdRaw(requestParameters: GetCustomerByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCustomerById200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getCustomerById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/customers/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetCustomerById200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getCustomerById(requestParameters: GetCustomerByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCustomerById200Response> {
        const response = await this.getCustomerByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getCustomerProductsRaw(requestParameters: GetCustomerProductsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCustomerProducts200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getCustomerProducts().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pagination'] != null) {
            queryParameters['pagination'] = requestParameters['pagination'];
        }

        if (requestParameters['filters'] != null) {
            queryParameters['filters'] = requestParameters['filters'];
        }

        if (requestParameters['sorting'] != null) {
            queryParameters['sorting'] = requestParameters['sorting'];
        }

        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = (requestParameters['startDate'] as any).toISOString();
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['endDate'] = (requestParameters['endDate'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/customers/{id}/products/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetCustomerProducts200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getCustomerProducts(requestParameters: GetCustomerProductsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCustomerProducts200Response> {
        const response = await this.getCustomerProductsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getCustomerPromotionsRaw(requestParameters: GetCustomerPromotionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCustomerPromotions200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getCustomerPromotions().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pagination'] != null) {
            queryParameters['pagination'] = requestParameters['pagination'];
        }

        if (requestParameters['filters'] != null) {
            queryParameters['filters'] = requestParameters['filters'];
        }

        if (requestParameters['sorting'] != null) {
            queryParameters['sorting'] = requestParameters['sorting'];
        }

        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = (requestParameters['startDate'] as any).toISOString();
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['endDate'] = (requestParameters['endDate'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/customers/{id}/promotions`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetCustomerPromotions200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getCustomerPromotions(requestParameters: GetCustomerPromotionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCustomerPromotions200Response> {
        const response = await this.getCustomerPromotionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getCustomerTagsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/customers/tags`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async getCustomerTags(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.getCustomerTagsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getCustomerVisitsRaw(requestParameters: GetCustomerVisitsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCustomerVisits200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getCustomerVisits().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pagination'] != null) {
            queryParameters['pagination'] = requestParameters['pagination'];
        }

        if (requestParameters['filters'] != null) {
            queryParameters['filters'] = requestParameters['filters'];
        }

        if (requestParameters['sorting'] != null) {
            queryParameters['sorting'] = requestParameters['sorting'];
        }

        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = (requestParameters['startDate'] as any).toISOString();
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['endDate'] = (requestParameters['endDate'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/customers/{id}/visits`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetCustomerVisits200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getCustomerVisits(requestParameters: GetCustomerVisitsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCustomerVisits200Response> {
        const response = await this.getCustomerVisitsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateCustomerRaw(requestParameters: UpdateCustomerOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateCustomer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/customers/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateCustomerRequestToJSON(requestParameters['updateCustomerRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateCustomer(requestParameters: UpdateCustomerOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateCustomerRaw(requestParameters, initOverrides);
    }

}
